import React, { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { UserCourseEdit } from '@components/pages';

function UserEditPage() {
  const { setPageName } = useOutletContext();

  useEffect(() => {
    setPageName('Cursos pagados');
  }, []);

  return (
    <section className="container-fluid">
      <article className="row card">
        <UserCourseEdit />
      </article>
    </section>
  );
}

export default UserEditPage;
